import { TPartnerDetailsData } from './partner-details.types';

export const mockedPartnerDetailsData: TPartnerDetailsData = {
  applications_description: 'string',
  city: 'string',
  company_name: 'string',
  country: 'string',
  postal_code: 'string',
  state: 'string',
  website: 'string',
  logo: 'https://ehr-marketplace-upload.s3.us-east-2.amazonaws.com/5.jpg',
  address: 'address',
};
